"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDashboardDateFilterIgnoredForInsight = exports.QueryWidgetFiltersService = void 0;
var tslib_1 = require("tslib");
var effects_1 = require("redux-saga/effects");
var queryService_1 = require("../store/_infra/queryService");
var sdk_model_1 = require("@gooddata/sdk-model");
var layoutSelectors_1 = require("../store/layout/layoutSelectors");
var insightsSelectors_1 = require("../store/insights/insightsSelectors");
var general_1 = require("../events/general");
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var catalogSelectors_1 = require("../store/catalog/catalogSelectors");
var displayFormResolver_1 = require("../utils/displayFormResolver");
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
exports.QueryWidgetFiltersService = queryService_1.createQueryService("GDC.DASH/QUERY.WIDGET.FILTERS", queryService);
function refMatchesMdObject(ref, mdObject, type) {
    return (sdk_model_1.areObjRefsEqual(ref, mdObject.ref) ||
        sdk_model_1.areObjRefsEqual(ref, sdk_model_1.idRef(mdObject.id, type)) ||
        sdk_model_1.areObjRefsEqual(ref, sdk_model_1.uriRef(mdObject.uri)));
}
function loadDisplayFormsForAttributeFilters(ctx, filters) {
    var refs, resolvedObjects;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                refs = filters.map(sdk_model_1.filterObjRef);
                return [4 /*yield*/, effects_1.call(displayFormResolver_1.resolveDisplayFormMetadata, ctx, compact_1.default(refs))];
            case 1:
                resolvedObjects = _a.sent();
                // if some display forms could not be resolved then there is something seriously amiss
                ts_invariant_1.default(isEmpty_1.default(resolvedObjects.missing));
                return [2 /*return*/, filters.map(function (filter) {
                        return {
                            filter: filter,
                            displayForm: resolvedObjects.resolved.get(sdk_model_1.filterObjRef(filter)),
                        };
                    })];
        }
    });
}
function selectDateDatasetsForDateFilters(state, filters) {
    var fromCatalog = catalogSelectors_1.selectAllCatalogDateDatasetsMap(state);
    return filters.map(function (filter) {
        var dateDataset = fromCatalog.get(sdk_model_1.filterObjRef(filter));
        return {
            dateDataset: dateDataset,
            filter: filter,
        };
    });
}
function getResolvedInsightAttributeFilters(ctx, widget, dashboardAttributeFilters, insightAttributeFilters) {
    var resolvedDashboardFilters;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(getResolvedAttributeFilters, ctx, widget, dashboardAttributeFilters)];
            case 1:
                resolvedDashboardFilters = _a.sent();
                return [2 /*return*/, tslib_1.__spread(resolvedDashboardFilters, insightAttributeFilters)];
        }
    });
}
function getResolvedAttributeFilters(ctx, widget, attributeFilters) {
    var attributeFilterDisplayFormPairs, attributeFilterDisplayFormPairsWithIgnoreResolved;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(loadDisplayFormsForAttributeFilters, ctx, attributeFilters)];
            case 1:
                attributeFilterDisplayFormPairs = _a.sent();
                attributeFilterDisplayFormPairsWithIgnoreResolved = resolveWidgetFilterIgnore(widget, attributeFilterDisplayFormPairs);
                return [2 /*return*/, attributeFilterDisplayFormPairsWithIgnoreResolved.map(function (item) { return item.filter; })];
        }
    });
}
function resolveWidgetFilterIgnore(widget, dashboardNonDateFilterDisplayFormPairs) {
    return dashboardNonDateFilterDisplayFormPairs.filter(function (_a) {
        var _b;
        var displayForm = _a.displayForm;
        var matches = displayForm && ((_b = widget.ignoreDashboardFilters) === null || _b === void 0 ? void 0 : _b.filter(sdk_model_1.isDashboardAttributeFilterReference).some(function (ignored) { return refMatchesMdObject(ignored.displayForm, displayForm, "displayForm"); }));
        return !matches;
    });
}
/**
 * Tests whether dashboard's date filter should not be applied on the insight included in the provided widget.
 *
 * This should happen for insights whose simple measures are all already set up with date filters. I guess ignoring
 * global date filter is desired because otherwise there is a large chance that the intersection of global date filter
 * and measure's date filters would lead to empty set and no data shown for the insight?
 */
function isDashboardDateFilterIgnoredForInsight(insight) {
    var simpleMeasures = sdk_model_1.insightMeasures(insight, sdk_model_1.isSimpleMeasure);
    return simpleMeasures.length > 0 && simpleMeasures.every(function (m) { var _a; return (_a = sdk_model_1.measureFilters(m)) === null || _a === void 0 ? void 0 : _a.some(sdk_model_1.isDateFilter); });
}
exports.isDashboardDateFilterIgnoredForInsight = isDashboardDateFilterIgnoredForInsight;
function selectResolvedInsightDateFilters(state, insight, dashboardDateFilters, insightDateFilters) {
    if (isDashboardDateFilterIgnoredForInsight(insight)) {
        return insightDateFilters;
    }
    return selectResolvedDateFilters(state, tslib_1.__spread(insightDateFilters, dashboardDateFilters));
}
function selectResolvedDateFilters(state, dateFilters) {
    var allDateFilterDateDatasetPairs = selectDateDatasetsForDateFilters(state, dateFilters);
    return resolveDateFilters(allDateFilterDateDatasetPairs);
}
function resolveDateFilters(allDateFilterDateDatasetPairs) {
    // go through the filters in reverse order using the first filter for a given dimension encountered
    // and strip useless all time filters at the end
    return allDateFilterDateDatasetPairs
        .filter(function (item) { return !!item.dateDataset; })
        .reduceRight(function (acc, curr) {
        var alreadyPresent = acc.some(function (item) {
            return refMatchesMdObject(sdk_model_1.filterObjRef(item), curr.dateDataset.dataSet, "dataSet");
        });
        if (!alreadyPresent) {
            acc.push(curr.filter);
        }
        return acc;
    }, [])
        .filter(function (item) { return !sdk_model_1.isAllTimeDateFilter(item); });
}
function queryWithInsight(ctx, widget, insight) {
    var widgetAwareDashboardFiltersSelector, widgetAwareDashboardFilters, effectiveInsightFilters, _a, dateFilters, attributeFilters;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                widgetAwareDashboardFiltersSelector = layoutSelectors_1.selectAllFiltersForWidgetByRef(widget.ref);
                return [4 /*yield*/, effects_1.select(widgetAwareDashboardFiltersSelector)];
            case 1:
                widgetAwareDashboardFilters = _b.sent();
                // add all time filter explicitly in case the date widgetAwareDashboardFilters are empty
                // this will cause the all time filter to be used instead of the insight date filter
                // if the dashboard date filter is not ignored by the widget
                if (!widgetAwareDashboardFilters.filter(sdk_model_1.isDateFilter).length && widget.dateDataSet) {
                    widgetAwareDashboardFilters.push(sdk_model_1.newAllTimeFilter(widget.dateDataSet));
                }
                effectiveInsightFilters = sdk_model_1.insightFilters(insight);
                return [4 /*yield*/, effects_1.all([
                        effects_1.select(selectResolvedInsightDateFilters, insight, widgetAwareDashboardFilters.filter(sdk_model_1.isDateFilter), effectiveInsightFilters.filter(sdk_model_1.isDateFilter)),
                        effects_1.call(getResolvedInsightAttributeFilters, ctx, widget, widgetAwareDashboardFilters.filter(sdk_model_1.isAttributeFilter), effectiveInsightFilters.filter(sdk_model_1.isAttributeFilter)),
                    ])];
            case 2:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), dateFilters = _a[0], attributeFilters = _a[1];
                return [2 /*return*/, tslib_1.__spread(dateFilters, attributeFilters, effectiveInsightFilters.filter(sdk_model_1.isMeasureValueFilter), effectiveInsightFilters.filter(sdk_model_1.isRankingFilter))];
        }
    });
}
function queryWithoutInsight(ctx, widget) {
    var widgetAwareDashboardFiltersSelector, widgetAwareDashboardFilters, _a, dateFilters, attributeFilters;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                widgetAwareDashboardFiltersSelector = layoutSelectors_1.selectAllFiltersForWidgetByRef(widget.ref);
                return [4 /*yield*/, effects_1.select(widgetAwareDashboardFiltersSelector)];
            case 1:
                widgetAwareDashboardFilters = _b.sent();
                return [4 /*yield*/, effects_1.all([
                        effects_1.select(selectResolvedDateFilters, widgetAwareDashboardFilters.filter(sdk_model_1.isDateFilter)),
                        effects_1.call(getResolvedAttributeFilters, ctx, widget, widgetAwareDashboardFilters.filter(sdk_model_1.isAttributeFilter)),
                    ])];
            case 2:
                _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), dateFilters = _a[0], attributeFilters = _a[1];
                return [2 /*return*/, tslib_1.__spread(dateFilters, attributeFilters)];
        }
    });
}
function queryService(ctx, query) {
    var _a, widgetRef, insight, correlationId, widgetSelector, widget, insightRef, insightSelector, linkedInsight;
    return tslib_1.__generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = query.payload, widgetRef = _a.widgetRef, insight = _a.insight, correlationId = query.correlationId;
                widgetSelector = layoutSelectors_1.selectWidgetByRef(widgetRef);
                return [4 /*yield*/, effects_1.select(widgetSelector)];
            case 1:
                widget = _b.sent();
                if (!widget) {
                    throw general_1.invalidQueryArguments(ctx, "Widget with ref " + sdk_model_1.objRefToString(widgetRef) + " does not exist on the dashboard", correlationId);
                }
                if (!insight) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.call(queryWithInsight, ctx, widget, insight)];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                if (!sdk_model_1.isInsightWidget(widget)) return [3 /*break*/, 6];
                insightRef = widget.insight;
                insightSelector = insightsSelectors_1.selectInsightByRef(insightRef);
                return [4 /*yield*/, effects_1.select(insightSelector)];
            case 4:
                linkedInsight = _b.sent();
                if (!linkedInsight) {
                    throw general_1.invalidQueryArguments(ctx, "Insight with ref " + sdk_model_1.objRefToString(insightRef) + " does not exist on the dashboard", correlationId);
                }
                return [4 /*yield*/, effects_1.call(queryWithInsight, ctx, widget, linkedInsight)];
            case 5: return [2 /*return*/, _b.sent()];
            case 6: return [4 /*yield*/, effects_1.call(queryWithoutInsight, ctx, widget)];
            case 7: return [2 /*return*/, _b.sent()];
        }
    });
}
//# sourceMappingURL=queryWidgetFilters.js.map